const MiResultadoIcon = ({color}) => {
  return (
    <svg
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7143 3.74805H3.28571C2.57563 3.74805 2 4.32368 2 5.03376V25.2143C2 25.9244 2.57563 26.5 3.28571 26.5H18.7143C19.4244 26.5 20 25.9244 20 25.2143V5.03376C20 4.32368 19.4244 3.74805 18.7143 3.74805Z"
        stroke={color}
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.03004 2.5708C8.23827 1.11727 9.48845 0 10.9996 0C12.5107 0 13.7609 1.11727 13.9691 2.5708H15.9284C16.7569 2.5708 17.4284 3.24237 17.4284 4.0708V6.21366C17.4284 7.04208 16.7569 7.71366 15.9284 7.71366H6.07129C5.24286 7.71366 4.57129 7.04209 4.57129 6.21366V4.0708C4.57129 3.24237 5.24286 2.5708 6.07129 2.5708H8.03004Z"
        fill={color}
      />
      <circle cx="11.0005" cy="2.78516" r="1.5" fill="white" />
      <path
        d="M12.6667 14.3333H15.5833C15.7917 14.3333 16 14.5417 16 14.75V17.25C16 17.5104 15.7917 17.6667 15.5833 17.6667H12.6667V20.5833C12.6667 20.8438 12.4583 21 12.25 21H9.75C9.48958 21 9.33333 20.8438 9.33333 20.5833V17.6667H6.41667C6.15625 17.6667 6 17.5104 6 17.25V14.75C6 14.5417 6.15625 14.3333 6.41667 14.3333H9.33333V11.4167C9.33333 11.2083 9.48958 11 9.75 11H12.25C12.4583 11 12.6667 11.2083 12.6667 11.4167V14.3333Z"
        fill={color}
      />
    </svg>
  );
};

export default MiResultadoIcon;
